import { render, staticRenderFns } from "./DashboardV2KpiCard.vue?vue&type=template&id=3f60c372&scoped=true&"
import script from "./DashboardV2KpiCard.vue?vue&type=script&lang=js&"
export * from "./DashboardV2KpiCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardV2KpiCard.vue?vue&type=style&index=0&id=3f60c372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f60c372",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VChip,VIcon,VProgressLinear})
